import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';

import type { ActivityType } from 'shared-types';

interface Props {
  count: number;
  mappedColors: { [type: string]: string };
  mappedNames: { [type: string]: { message: string; placeholder: string } };
  type: ActivityType;
}

const MyTeamActivityChartLabel = ({
  count,
  mappedColors,
  mappedNames,
  type
}: Props) => {
  const { theme } = useReduxState();

  if (!count) return null;

  return (
    <div className="chart-label">
      <div className="icon" style={{ backgroundColor: mappedColors[type] }} />
      <div className="count">{count}</div>
      <div className="label">
        {getMessageWithPlaceholders({
          message: mappedNames[type].message,
          placeholders: { [mappedNames[type].placeholder]: '' }
        })}
      </div>

      <style jsx>{`
        .icon {
          border-radius: 20px;
          display: inline-block;
          margin-right: 7px;
          margin-top: 1px;
          height: 11px;
          width: 11px;
        }
        .count {
          color: ${theme.textColorLight};
          display: inline-block;
          font-size: 1.8rem;
          font-weight: 700;
          margin-right: 5px;
        }
        .label {
          color: ${theme.textColorLighter};
          display: inline-block;
          font-size: 1.4rem;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default MyTeamActivityChartLabel;
